<template>
    <div>
        <input
            :type="type"
            :value="value"
            :placeholder="label"
            :class="{
                'bg-transparent rounded w-full font-light outline-none focus:outline-none high-contrast:border-yellow-300 high-contrast:placeholder:text-yellow-300/50 high-contrast:text-yellow-300': true,
                'p-3 text-1375xl': !inputSmall,
                'p-1 text-sm': inputSmall,
                edited: hasValue,
                'border-orange': hasErrors,
                [colorClass]: true,
            }"
            @input="$emit('input', $event.target.value)"
            @keyup.enter="submit()"
        />
        <span
            v-for="(error, index) in inputErrors"
            v-bind:key="`error-${index}`"
            class="validation-error">
                {{ error }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: "text"
        },
        label: String,
        topClass: String,
        inputSmall: Boolean,
        errors: {
            type: Object,
            default: () => {}
        },
        colorClass: {
            type: String,
            default: "border border-grey-200 placeholder-grey-200 text-grey-300"
        },
    },
    computed: {
        hasValue() {
            return !_.isEmpty(this.value);
        },
        hasLabel() {
            return !_.isEmpty(this.label);
        },
        hasErrors() {
            return _.isArray(this.inputErrors) && this.inputErrors.length > 0;
        },
        inputErrors() {
            return _.get(this.errors, this.name, []);
        },
        inputPlaceholder() {
            return this.__(this.placeholder) ?? this.__(this.label);
        }
    },
    methods: {
        submit() {
            this.$emit("submitted");
        }
    }
};
</script>
